"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Menu_1 = __importDefault(require("semantic-ui-react/dist/commonjs/collections/Menu"));
var Item_1 = __importDefault(require("./Item/Item"));
/**
 * The Footer spans to the available width, similar to the Header component, and the links within align to the main content.
 * @child ./Item/Item.tsx
 */
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        var _a = this.props, className = _a.className, copyrightText = _a.copyrightText, children = _a.children, menuProps = __rest(_a, ["className", "copyrightText", "children"]);
        return (React.createElement(Menu_1.default, __assign({}, menuProps, { className: (className || '') + ' page-footer' }),
            React.createElement(Menu_1.default.Menu, { className: "footer-menu" }, React.Children.map(children, function (child) {
                var c = child;
                return React.cloneElement(c, __assign(__assign({}, c.props), { link: true }));
            })),
            React.createElement(Footer.Item, { position: "right" },
                React.createElement("span", { className: "copyright" }, copyrightText))));
    };
    Footer.Item = Item_1.default;
    Footer.defaultProps = {
        copyrightText: '© ' + (new Date().getFullYear()) + ' Honeywell International Inc.'
    };
    return Footer;
}(react_1.Component));
exports.default = Footer;
